'use client'

import { SupportedCurrency, useCurrency } from '@/lib/currency'

export default function CurrencySwitcher() {
	const { currency, setCurrency } = useCurrency()
	return (
		<select
			value={currency}
			onChange={(e) => setCurrency(e.target.value as SupportedCurrency | 'NGN')}
			className="px-2 py-1 border border-gray-300 rounded text-sm"
			title="Select currency"
		>
			{/* <option value="USD">USD ₦</option> */}
			<option value="NGN">NGN ₦</option>
		</select>
	)
}



